import { createBrowserOnlyLazyComponent } from '@dbh/react-lazy';

var index = createBrowserOnlyLazyComponent(()=>import('./component-e2baaaf3.js'/* webpackChunkName: "dbh.lazy-loaded-booking-details-entry-content" */));

export { index as default };
